module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-6 "
  }, [_c('div', {
    staticClass: "bdy mt-5 ml-5 mr-5 left"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary ml-0 disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("COMING SOON")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('form', {
    staticClass: "mb-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.newInterest()
      }
    }
  }, [_c('div', {
    staticClass: "form-row  mt-4"
  }, [_c('div', {
    staticClass: "col-sm-7 pl-1 pr-0 pb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupFormFields.email),
      expression: "signupFormFields.email"
    }],
    staticClass: "form-control ml-0",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Your e-mail address",
      "required": ""
    },
    domProps: {
      "value": (_vm.signupFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "link-text mt-4 mb-4 ml-1"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#007D53"
    },
    attrs: {
      "to": "/central_analytics"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left",
    staticStyle: {
      "padding-top": "2px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Back to MSDAT")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 "
  }), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: " mt-3 mb-4 tittle"
  }, [_vm._v("NHMIS Analysis "), _c('br'), _vm._v(" Dashboard")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-body  "
  }, [_c('p', {
    staticClass: "text-left msg"
  }, [_vm._v("This dashboard provides a single transparent view of data from health facilities across the country. By transparently visualizing data and trends, we intend improving the debate and focus on data quality and its use, so as to improve our overall understanding of key trends and progress within the health sector.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-body  mt-3"
  }, [_c('p', {
    staticClass: "text-left msg2"
  }, [_vm._v("This resource is currently not available. If you would like to be informed about its development, please leave your contact information below.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 pl-1"
  }, [_c('button', {
    staticClass: "btn btn-primary mb-2 pr-4 pl-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Keep me Updated! ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12 bg-white right pr-0 pl-0",
    staticStyle: {
      "height": "80vh",
      "background": "url(static/img/subdashboards/)"
    },
    attrs: {
      "id": "image"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/img/subdashboards/nhmis.jpg",
      "alt": "NHMIS Analysis image"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c808f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/nhmisAnalysis.vue
// module id = 956
// module chunks = 2